import { useEffect, useState } from "react";
import {
  OPTIONAL_FOOTER_DOCUMENTS,
  toPublicAssetHref,
} from "../config/legalDocuments";

/**
 * Verifica (una sola vez por sesión) qué PDFs opcionales del footer existen en
 * /docs/. El SPA responde index.html (200, text/html) para rutas que no
 * existen, así que solo cuenta como disponible una respuesta OK con tipo PDF.
 */
let availabilityPromise = null;

async function probeDocument(path) {
  try {
    const response = await fetch(toPublicAssetHref(path), {
      method: "HEAD",
      cache: "no-cache",
    });
    const type = response.headers.get("content-type") || "";
    return response.ok && /pdf/i.test(type);
  } catch {
    return false;
  }
}

function loadAvailability() {
  if (!availabilityPromise) {
    const docs = OPTIONAL_FOOTER_DOCUMENTS.filter((doc) => !doc.url && doc.file);
    availabilityPromise = Promise.all(
      docs.map(async (doc) => [doc.key, await probeDocument(doc.file)])
    ).then((entries) => Object.fromEntries(entries));
  }
  return availabilityPromise;
}

/** @returns {Record<string, boolean>} key del documento → PDF disponible */
export default function useOptionalDocuments() {
  const [available, setAvailable] = useState({});

  useEffect(() => {
    if (typeof fetch !== "function") return undefined;
    let cancelled = false;
    loadAvailability().then((result) => {
      if (!cancelled) setAvailable(result);
    });
    return () => {
      cancelled = true;
    };
  }, []);

  return available;
}
